module.exports = __webpack_public_path__ + "img/Weapon_112.dfc95ea4.png";